<div>
  <nz-page-header nzBackIcon class="bg-slate-100" (nzBack)="routeBack()" [nzGhost]="false">
    <nz-page-header-title class="text-primary">
      {{ (isEditMode ? 'itineraryTemplates.addEdit.editPageTitle' : 'itineraryTemplates.addEdit.pageTitle') | transloco }}
    </nz-page-header-title>
  </nz-page-header>
</div>

<nz-spin [nzSpinning]="cardLoading">
  <nz-card class="my-8">
    <div><h5>{{ 'itineraryTemplates.addEdit.tourInformation' | transloco }}</h5></div>
    <nz-divider></nz-divider>

    <form nz-form [formGroup]="tourForm" nzLayout="vertical">

      <!-- Row 1: Type | Number of Days | Primary Currency -->
      <div class="grid md:grid-cols-3 gap-10">
        <!-- Type -->
        <div>
          <nz-form-item>
            <nz-form-label nzRequired nzFor="type">
              {{ 'itineraryTemplates.addEdit.fields.type' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="typeCheck">
              <nz-select
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectType' | transloco"
                formControlName="type"
                nzShowSearch>
                <nz-option
                  *ngFor="let c of SETTINGS.ITINERARY_TYPES"
                  [nzValue]="c.value"
                  [nzLabel]="c.label">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #typeCheck>
              <span *ngIf="formErrors.type?.required">{{ 'itineraryTemplates.addEdit.errors.typeRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>
        </div>

        <!-- Number of Days -->
        <div>
          <nz-form-item>
            <nz-form-label nzRequired nzFor="noOfDays">
              {{ 'itineraryTemplates.addEdit.fields.numberOfDays' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="'itineraryTemplates.addEdit.errors.noOfDaysRequired' | transloco">
              <nz-input-number
                class="w-full pax-input"
                formControlName="noOfDays"
                [nzMin]="1"
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.enter' | transloco">
              </nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Primary Currency -->
        <div>
          <nz-form-item>
            <nz-form-label nzRequired nzFor="currency">
              {{ 'itineraryTemplates.addEdit.fields.primaryCurrency' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="currencyCheck"
                             [nzExtra]="'itineraryTemplates.addEdit.extras.primaryCurrency' | transloco">
              <nz-select
                formControlName="currency"
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectCurrency' | transloco"
                nzShowSearch>
                <nz-option
                  *ngFor="let cur of sortOrderCurrency(currencies)"
                  [nzValue]="cur.cc"
                  [nzLabel]="cur.cc">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #currencyCheck>
              <span *ngIf="formErrors.currency?.required">{{ 'itineraryTemplates.addEdit.errors.currencyRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>
        </div>
      </div>

      <!-- Row 2: Number of Pax | Season (Optional) | Secondary Currency -->
      <div class="grid md:grid-cols-3 gap-10">
        <!-- Number of Pax -->
        <div class="mt-1.5">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="pax">
              {{ 'itineraryTemplates.addEdit.fields.numberOfPax' | transloco }}
            </nz-form-label>
            <nz-form-control formGroupName="pax"
                             [nzErrorTip]="'itineraryTemplates.addEdit.errors.paxRequired' | transloco">
              <div class="flex gap-4">
                <div class="flex flex-col gap-2">
                  <nz-input-number
                    formControlName="adults"
                    [nzMin]="1"
                    [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.adults' | transloco"
                    class="xl:w-full lg:w-3/5 pax-input">
                  </nz-input-number>
                  <nz-tag class="m-0" nzColor="purple">
                    {{ 'itineraryTemplates.addEdit.fields.adult' | transloco }}
                  </nz-tag>
                </div>
                <div class="flex flex-col gap-2">
                  <nz-input-number
                    formControlName="children"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.children' | transloco"
                    class="xl:w-full lg:w-3/5 pax-input">
                  </nz-input-number>
                  <nz-tag class="m-0" nzColor="purple">
                    {{ 'itineraryTemplates.addEdit.fields.children' | transloco }}
                  </nz-tag>
                </div>
                <div class="flex flex-col gap-2">
                  <nz-input-number
                    formControlName="infants"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.infants' | transloco"
                    class="xl:w-full lg:w-3/5 pax-input">
                  </nz-input-number>
                  <nz-tag class="m-0" nzColor="purple">
                    {{ 'itineraryTemplates.addEdit.fields.infant' | transloco }}
                  </nz-tag>
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Season (Optional) -->
        <div>
          <nz-form-item>
            <nz-form-label nzFor="season">
              <span class="flex items-center justify-center gap-2">
                {{ 'itineraryTemplates.addEdit.fields.season' | transloco }}
                <span
                  nz-tooltip
                  [nzTooltipTitle]="'itineraryTemplates.addEdit.tooltips.predefineSeasons' | transloco">
                  <span nz-icon nzType="info-circle" nzTheme="fill" class="text-gray-400 cursor-pointer mb-2"></span>
                </span>
              </span>
            </nz-form-label>
            <nz-form-control>
              <nz-select
                class="w-full"
                formControlName="season"
                nzAllowClear
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectSeason' | transloco">
                <nz-option
                  *ngFor="let season of seasonCategory"
                  [nzValue]="season._id"
                  [nzLabel]="season.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Secondary Currency -->
        <div>
          <nz-form-item>
            <nz-form-label nzFor="secondaryCurrency">
              {{ 'itineraryTemplates.addEdit.fields.secondaryCurrency' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="secondaryCurrencyCheck"
                             [nzExtra]="'itineraryTemplates.addEdit.extras.secondaryCurrency' | transloco">
              <nz-select
                formControlName="secondaryCurrency"
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectSecondaryCurrency' | transloco"
                nzShowSearch>
                <nz-option
                  *ngFor="let cur of sortOrderCurrency(currencies)"
                  [nzValue]="cur.cc"
                  [nzLabel]="cur.cc">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #secondaryCurrencyCheck>
              <span *ngIf="formErrors.secondaryCurrency?.required">{{ 'itineraryTemplates.addEdit.errors.secondaryCurrencyRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>
        </div>
      </div>

      <!-- Row 3: empty | empty | Language + Exchange Rate -->
      <div class="grid md:grid-cols-3 gap-10">
        <div></div>
        <div></div>
        <div>
          <!-- Exchange Rate -->
          <nz-form-item *ngIf="tourForm.get('secondaryCurrency')?.value">
            <nz-form-label nzRequired nzFor="exchangeRate">
              {{ 'itineraryTemplates.addEdit.fields.exchangeRate' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="exchangeRateCheck"
                             [nzExtra]="'itineraryTemplates.addEdit.extras.exchangeRate' | transloco">
              <nz-input-number
                [nzFormatter]="formatter"
                [nzParser]="parser"
                [nzPrecision]="2"
                [nzStep]="0.01"
                class="w-full"
                formControlName="exchangeRate"
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.enterRate' | transloco">
              </nz-input-number>
            </nz-form-control>
            <ng-template #exchangeRateCheck>
              <span *ngIf="formErrors.exchangeRate?.required">{{ 'itineraryTemplates.addEdit.errors.exchangeRateRequired' | transloco }}</span>
              <span *ngIf="formErrors.exchangeRate?.min">{{ 'itineraryTemplates.addEdit.errors.exchangeRateMin' | transloco }}</span>
            </ng-template>
          </nz-form-item>

          <!-- Language -->
          <nz-form-item>
            <nz-form-label nzRequired nzFor="language">
              {{ 'itineraryTemplates.addEdit.fields.language' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="languageCheck">
              <nz-select
                formControlName="language"
                [nzDisabled]="isEditMode"
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectLanguage' | transloco">
                <nz-option
                  *ngFor="let l of orderByName(getSelectedLanguagesObjectArray())"
                  [nzValue]="l.code"
                  [nzLabel]="l.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #languageCheck>
              <span *ngIf="formErrors.language?.required">{{ 'itineraryTemplates.addEdit.errors.languageRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>
        </div>
      </div>

      <nz-divider></nz-divider>

      <!-- Category & Tags -->
      <div><h5>{{ 'itineraryTemplates.addEdit.categoryAndTags' | transloco }}</h5></div>
      <div class="grid md:grid-cols-2 gap-10 my-6">
        <div>
          <nz-form-item>
            <nz-form-label nzFor="category">
              {{ 'itineraryTemplates.addEdit.fields.category' | transloco }}
            </nz-form-label>
            <nz-form-control>
              <nz-select
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectCategory' | transloco"
                formControlName="category"
                nzShowSearch>
                <nz-option
                  *ngFor="let c of activeCategories"
                  [nzValue]="c._id"
                  [nzLabel]="c.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label nzFor="tags">
              {{ 'itineraryTemplates.addEdit.fields.tags' | transloco }}
            </nz-form-label>
            <nz-form-control>
              <nz-select
                [nzShowArrow]="true"
                nzMode="tags"
                [nzPlaceHolder]="'itineraryTemplates.addEdit.placeholders.selectTags' | transloco"
                formControlName="tags"
                nzAllowClear>
                <nz-option
                  *ngFor="let c of activeTags"
                  [nzValue]="c._id"
                  [nzLabel]="c.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <nz-divider></nz-divider>

      <!-- Actions -->
      <div class="flex justify-end mt-6">
        <button
          nz-button
          nzType="primary"
          (click)="saveTemplate()"
          [disabled]="tourForm.invalid">
          {{ (isEditMode ? 'itineraryTemplates.addEdit.actions.update' : 'itineraryTemplates.addEdit.actions.next') | transloco }}
        </button>
      </div>
    </form>
  </nz-card>
</nz-spin>
